import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../Components/InnerLayout/Headerbar";
import UserInterface from "../Components/InnerLayout/UserInterface";
const Onlife = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
      </div>
    </UserInterface>
  );
};
export default Onlife;
